export default __webpack_public_path__ + "static/media/team117.e30d42d3.JPG";